import { useMemo } from "react";
import { Calendar as Cal } from "@/components/ui/calendar";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Calendar as CalIcon } from "lucide-react";
import { cn } from "@/lib/utils";

function parseISO(s) {
  if (!s) return undefined;
  const [y, m, d] = s.split("-").map(Number);
  if (!y || !m || !d) return undefined;
  return new Date(y, m - 1, d);
}

function fmtISO(d) {
  if (!d) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function DatePicker({ value, onChange, placeholder = "Pick a date", testid, disabled, className }) {
  const date = useMemo(() => parseISO(value), [value]);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          data-testid={testid}
          disabled={disabled}
          variant="outline"
          className={cn(
            "w-full h-9 justify-start gap-2 text-left font-normal",
            !value && "text-slate-400",
            className,
          )}
        >
          <CalIcon className="h-3.5 w-3.5" />
          {value ? <span className="text-slate-900">{value}</span> : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Cal
          mode="single"
          selected={date}
          onSelect={(d) => onChange(fmtISO(d))}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
